class MilestoneTabs extends HTMLElement {
    constructor() {
        super();
        this.currentIndex = 0;
        this.intervalId = null;
    }

    connectedCallback() {
        this.checkboxes = this.querySelectorAll("input[type='radio']");
        this.intervalSeconds = this.getAttribute("data-time-interval") || 2;
        this.container = this.querySelector('.tabs-container');
        
        if (this.checkboxes.length > 0) {
            this.checkboxes[0].checked = true;
            this.scrollToLabel(this.checkboxes[0]);
        }
        
        this.checkboxes.forEach((checkbox, index) => {
            checkbox.addEventListener('click', () => this.handleCheckboxClick(index));
        });
        
        this.setupEventListeners();
        this.startInterval();
    }

    startInterval() {
        this.intervalId = setInterval(() => this.toggleCheckbox(), this.intervalSeconds * 1000);
    }

    stopInterval() {
        clearInterval(this.intervalId);
    }

    toggleCheckbox() {
        if (this.checkboxes.length > 0) {
            this.checkboxes[this.currentIndex].checked = false;
            this.currentIndex++;
            if (this.currentIndex >= this.checkboxes.length) {
                this.currentIndex = 0;
            }
            this.checkboxes[this.currentIndex].checked = true;
            this.scrollToLabel(this.checkboxes[this.currentIndex]);
        }
    }

    handleCheckboxClick(index) {
        this.stopInterval();
        this.currentIndex = index;
        this.scrollToLabel(this.checkboxes[index]);
        this.startInterval();
    }

    scrollToLabel(checkbox) {
        const label = this.querySelector(`label[for="${checkbox.id}"]`);
        if (label) {
            const containerLeft = this.container.getBoundingClientRect().left;
            const labelLeft = label.getBoundingClientRect().left;
            const scrollOffset = labelLeft - containerLeft;
            this.container.scrollTo({
                left: this.container.scrollLeft + scrollOffset,
                behavior: 'smooth'
            });
        }
    }

    setupEventListeners() {
        let isTouchDevice = 'ontouchstart' in document.documentElement;
        if (isTouchDevice) {
            this.addEventListener('touchstart', () => {
                this.stopInterval();
            });
            this.addEventListener('touchend', () => {
                this.startInterval();
            });
        } else {
            // Handle hover on desktop
            this.addEventListener('mouseenter', () => this.stopInterval());
            this.addEventListener('mouseleave', () => this.startInterval());
        }
    }
}

customElements.define('milestone-tabs', MilestoneTabs);
